import AnalyticsAlarms from './component'

export default AnalyticsAlarms
